import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DriverDashboard from '../DriverDashboard';
import DriverAvailabilityCard from '../driver-availability/DriverAvailabilityCard';
import OperationalUnavailabilityWorkspace from '../operational-unavailability/OperationalUnavailabilityWorkspace';
import OperationsTabBar from './OperationsTabBar';

const TAB_PREFIX = 'driver-operations';

const DriverOperationsWorkspace = ({ currentEntity }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('myTrips');
  const entityId = currentEntity?.entityId;
  const tabs = [
    { id: 'myTrips', label: t('operations.myTrips') },
    { id: 'findTrip', label: t('operations.findTrip') },
    { id: 'serviceBlocks', label: t('operations.serviceBlocks') }
  ];
  const panelIds = {
    myTrips: `${TAB_PREFIX}-panel-myTrips`,
    findTrip: `${TAB_PREFIX}-panel-findTrip`
  };

  return (
    <div className="mx-auto max-w-7xl px-4 pb-8 sm:px-6 lg:px-8">
      {entityId && (
        <div className="mt-6">
          <DriverAvailabilityCard entityId={entityId} />
        </div>
      )}

      <div className="mt-6">
        <OperationsTabBar
          tabs={tabs}
          activeTab={activeTab}
          onChange={setActiveTab}
          idPrefix={TAB_PREFIX}
        />
      </div>

      <DriverDashboard
        currentEntity={currentEntity}
        activeTab={activeTab}
        panelIds={panelIds}
        tabPrefix={TAB_PREFIX}
      />

      <section
        id={`${TAB_PREFIX}-panel-serviceBlocks`}
        role="tabpanel"
        aria-labelledby={`${TAB_PREFIX}-tab-serviceBlocks`}
        hidden={activeTab !== 'serviceBlocks'}
        className="pt-6"
      >
        {activeTab === 'serviceBlocks' && (
          <OperationalUnavailabilityWorkspace
            entityId={entityId}
            adminMode={false}
          />
        )}
      </section>
    </div>
  );
};

export default DriverOperationsWorkspace;
